var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ArticleItem',_vm._b({staticClass:"hobby-item-container",scopedSlots:_vm._u([{key:"thumbCover",fn:function(){return [_c('div',{staticClass:"thumb-cover"},[_c('SvgIcon',{attrs:{"icon":_vm.play},on:{"click":e => _vm.$emit('playMusic', _vm.content, e)}})],1)]},proxy:true}])},'ArticleItem',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }